import styles from 'css/src/components/app/Waveform.module.scss';

import React from 'react';
import classNames from 'classnames';

type WaveformBarPresentationProps = {
    x: number;
    y: number;
    width: number;
    height: number;
    shaded: boolean;
};

const WaveformBarPresentation = ({ x, y, width, height, shaded }: WaveformBarPresentationProps) => {
    const rectClassName = classNames(styles['waves'], {
        [styles['shaded']]: shaded,
    });
    return (
        <rect
            x={x}
            y={y}
            width={width}
            height={height}
            className={rectClassName}
            data-testid="waveform-bar"
            data-shaded={shaded ? '' : undefined}
        />
    );
};

const WaveformBarMemoized = React.memo(WaveformBarPresentation);
const WaveformBar = WaveformBarMemoized;

export default WaveformBar;
